import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import emailSuccessIcon from 'assets/images/email_success.png';
import { useSession } from 'context/SessionContext';
import './EmailInputEmailVerified.scss';
import {
  buildLoginPath,
  buildPasswordCreatePath,
  buildRegistrationSuccessPath,
} from 'utils/pathBuilder';
// import { SessionInfo } from 'types/dto/profile';
import { fetchProfile } from 'services/profileService';
import { checkUserStatus } from 'services/loginService';

const EmailInputEmailVerified: React.FC = () => {
  const { t } = useTranslation('email_input_email_verified');
  const { session } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndNavigate = async () => {
      const { is_migrated, is_password_created, is_email_verified } = await getIsPasswordCreated();
      let route = buildRegistrationSuccessPath();
      if (!session) {
        route = buildLoginPath();
      }
      if (!is_password_created && is_email_verified) {
        route = buildPasswordCreatePath();
      }
      if (is_password_created && is_email_verified && is_migrated === '1') {
        route = buildLoginPath();
      }
      navigate(route);
    };
    checkAndNavigate();
  }, [navigate, session]);

  const getIsPasswordCreated = async (): Promise<{
    is_migrated: boolean | string;
    is_password_created: boolean;
    is_email_verified: boolean;
  }> => {
    try {
      // const sessionInfo: SessionInfo = {
      //   sessionID: session?._tk || '',
      //   juicyAppUniqueId: session?._id || '',
      //   customerName: session?._n1 || '',
      //   customerNameZh: session?._n2 || '',
      //   preflang: session?._lg || '',
      //   lastPickUpMethodCode: session?._pu || '',
      //   needTnC: session?._tc || false,
      //   isPasswordCreated: session?._vp || false,
      //   isEmailVerified: session?._ve || false,
      //   parameterCount: 0,
      //   status: session?._st || 'new',
      // };
      const profileData = await fetchProfile('/profile');
      // const is_migrated = profileData.loyalty_account.is_migrated || '';
      const mobile = profileData.mobile;
      const countryCode = '+852';
      const currentPhone = mobile.split(' ')[1];
      const statusResponse = await checkUserStatus(countryCode, currentPhone);

      return {
        is_migrated: profileData.loyalty_account.is_migrated || '',
        is_password_created: statusResponse.is_password_created,
        is_email_verified: statusResponse.is_email_verified,
      };
    } catch (error) {
      console.error('Validation failed:', error);
      return {
        is_migrated: '',
        is_password_created: false,
        is_email_verified: false,
      };
    }
  };

  return (
    <ResultDisplay
      title={t('title')}
      imageUrl={emailSuccessIcon}
      showFooter={false}
    >
      <div className="email-input-email-verified-message">
        <div>{t('message')}</div>
      </div>
    </ResultDisplay>
  );
};

export default EmailInputEmailVerified;
